import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0TagRaw } from '@factorialco/f0-react'
import { NodeAttributesFragment } from 'generated/resources/graphql'

import EmptyState from 'modules/job_catalog/components/TreeNodeAttributes/EmptyState'
import {
  DEFAULT_CATEGORIES,
  NODE_TYPES,
  formatConditionName,
  formatWorkingConditionValue,
  getTextFromNodeType as getNodeTypeLabel,
  isNodeType,
  nodeTypeIcon,
} from 'modules/job_catalog/lib/nodesUtils'

interface WorkingConditionItem {
  id: string
  name: string
  value: string
}

interface WorkingConditionsAttributesProps {
  items: NodeAttributesFragment[]
}

interface WorkingConditionsAttributeProps {
  item: NodeAttributesFragment
}

const WorkingConditionsAttribute = ({ item }: WorkingConditionsAttributeProps) => {
  const { items }: { items: WorkingConditionItem[] } = JSON.parse(item.serializedValue)

  const definedAt = getNodeTypeLabel(item.definedAt)
  const nodeType = isNodeType(item.definedAt) ? item.definedAt : NODE_TYPES.ROOT

  const icon = nodeTypeIcon(nodeType)

  return (
    <Box gap="s24">
      {items.map((condition) => (
        <Box key={condition.id}>
          <Box flexDirection="row" justifyContent="spaceBetween">
            <Text.Normal weight="normal" size="200" color="grey800">
              {formatConditionName(condition.name)}
            </Text.Normal>
            {definedAt ? <F0TagRaw text={definedAt} icon={icon} /> : null}
          </Box>

          <Text.Normal weight="medium" size="200" color="grey1000">
            {formatWorkingConditionValue(condition)}
          </Text.Normal>
        </Box>
      ))}
    </Box>
  )
}

const WorkingConditionsAttributes = ({ items }: WorkingConditionsAttributesProps) => {
  if (!items || items.length === 0) {
    return <EmptyState category={DEFAULT_CATEGORIES.WORKING_CONDITIONS} />
  }
  return (
    <Box paddingX="s24" paddingY="s20">
      {items.map((item) => (
        <WorkingConditionsAttribute key={item.id} item={item} />
      ))}
    </Box>
  )
}

export default WorkingConditionsAttributes
